var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconScreenshotsNext = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m2 1.405 6 5-6 5",
  stroke: "#002349",
  strokeWidth: 1.6,
  strokeLinecap: "square",
  strokeLinejoin: "round"
})));

export default SvgIconScreenshotsNext;